module.exports = "/_next/static/images/pdf-db031c9f5df1f91551febf228d7befb0.svg";